import { useEffect, useState } from "react"

// import { useScenarioType } from "./ScenarioTypeContext"

import AddButton from "./AddButton"
import InputWithErrorMessage from "./InputWithErrorMessage"

const defaultLabelGenerator = (id) => `label-${id}`

const AssociateEntity = ({
    entityDesc,
    choices=[],
    addHandler,
    genIDs=false,
    idGenerator=defaultLabelGenerator,
    uniqueIDs=[]
}) => {
    // const { uniqueIDs } = useScenarioType()
    const [entityType, setEntityType] = useState(null)
    const [entityName, setEntityName] = useState(null)
    const [selectedID, setSelectedID] = useState("")
    const [selectedIDErrMsg, setSelectedIDErrMsg] = useState("")
    const [id, setID] = useState("")
    const [idErrMsg, setIDErrMsg] = useState("")

    const onAdd = (event) => {
        if ("" !== selectedID) {
            addHandler(entityType, id, selectedID)
            setSelectedID("")
            setSelectedIDErrMsg("")
            setID("")
            setIDErrMsg("")
        } else {
            setSelectedIDErrMsg(`Please select a/an ${entityName}`)
        }
    }

    const selectedIDChangeHandler = (event) => {
        const {value} = event.target
        if (genIDs) {
            const newID = idGenerator(value)
            setID(newID)
            setIDErrMsg(uniqueIDs.includes(newID) ? "Not unique" : "")
        }
        setSelectedID(value)
    }

    const idChangeHandler = (event) => {
        const {value} = event.target
        setID(value)
        setIDErrMsg(uniqueIDs.includes(value) ? "Not unique" : "")
    }

    useEffect(
        () => {
            if (!entityType) {
                setEntityType(entityDesc.type)
                setEntityName(entityDesc.name)
            }
        }, [entityDesc, entityType]
    )

    return (
        <div className="add-entity">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>{entityDesc.name}</th>
                        {genIDs &&
                            <th>ID (auto-gen cross-listed will be dups, append number)</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <b>Add {entityName}</b>
                        </td>
                        <td>
                            <select value={selectedID} onChange={selectedIDChangeHandler}>
                                <option value=""></option>
                                {choices.map(choice =>
                                    <option key={choice.id} value={choice.id}>{choice.label}</option>
                                )}
                            </select>
                            <br/>
                            <span className="err-msg">
                                {selectedIDErrMsg}
                            </span>
                        </td>
                        {genIDs &&
                            <td>
                                <InputWithErrorMessage
                                    value={id}
                                    errMsg={idErrMsg}
                                    size={60}
                                    onChange={idChangeHandler}
                                />
                            </td>
                        }
                        <td>
                            <AddButton addHandler={onAdd}/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default AssociateEntity